interface SpinnerProps {
    size?: number;
    color?: string;
}

export default function Spinner({
    size = 24,
    color = "text-gray-500",
}: SpinnerProps) {
    return (
        <div
            className={`animate-spin rounded-full border-2 border-t-transparent ${color}`}
            style={{ width: size, height: size }}
        />
    );
}
